// Angular
import { Component, OnInit, inject, ChangeDetectionStrategy, signal } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { AsyncPipe } from '@angular/common';
// Transloco
import { TranslocoService, TranslocoDirective } from '@jsverse/transloco';
// ng-bootstrap
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
// Rxjs
import { Observable } from 'rxjs';
// Component
import { MobileMenusComponent } from '../quick-panels/mobile-menus/mobile-menus.component';
// Utils
import { SavedListService } from '@core/utils';
// Environment
import { environment } from '@environment';
import { InlineSVGModule } from 'ng-inline-svg-2';
// Components
import { QuickSearchComponent } from '../quick-search/quick-search.component';
import { QuickCartCounterComponent } from '../quick-cart-counter/quick-cart-counter.component';
import { ThemeModeSwitchComponent } from '../theme-mode-switch/theme-mode-switch.component';
import { VisitorSettingComponent } from '../visitor-setting/visitor-setting.component';
import { UserInfoComponent } from '../user-info/user-info.component';
import { SellerOwnStockBannerComponent } from '../seller-own-stock-banner/seller-own-stock-banner.component';
import { QuickSavedSearchesCounterComponent } from '../quick-saved-searches-counter/quick-saved-searches-counter.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslocoDirective, InlineSVGModule, RouterLink, RouterLinkActive, QuickSearchComponent, QuickCartCounterComponent, QuickSavedSearchesCounterComponent, ThemeModeSwitchComponent, VisitorSettingComponent, UserInfoComponent, SellerOwnStockBannerComponent, AsyncPipe],
})
export class HeaderComponent implements OnInit {
  // Private
  private readonly offcanvasService = inject(NgbOffcanvas);
  private readonly translocoService = inject(TranslocoService);
  private readonly savedListService = inject(SavedListService);

  // Public
  env = environment;
  languageChange$: Observable<string>;

  // Signal
  count = this.savedListService.savedPartsCountSignal;

  /**
   * Oninit
   * @memberof HeaderComponent
   */
  ngOnInit(): void {
    // Get Current live language
    this.languageChange$ = this.translocoService.langChanges$;
  }

  /**
   * Open Mobile Menu
   * @memberof HeaderComponent
   */
  openMobileMenu(): void {
    this.offcanvasService.open(MobileMenusComponent);
  }
}
